



// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Box, Typography } from '@mui/material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { API_BASE_URL } from '../../config';
// import { LoadingSpinner } from '../../Components/spinner/spinner';

// export const StaffAssetValuationComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl. No', width: 70 },

//     // Assigned FE details through nested serializers
//     { id: 'name_of_fe', field: 'name_of_fe', headerName: 'Financial Establishment', width: 250 },
//     { id: 'name_of_ca', field: 'name_of_ca', headerName: 'Competent Authority', width: 200 },

//     // Nested Asset3_2 notification info
//     { id: 'notification', field: 'notification', headerName: 'Notification', width: 150 },
//     { id: 'date', field: 'date', headerName: 'Date', width: 120 },
//     { id: 'notification_no', field: 'notification_no', headerName: 'Notification No', width: 150 },

//     // From AssetPropertyDetails
//     { id: 'property_detals', field: 'property_detals', headerName: 'Property Details', width: 200 },
//     { id: 'survey_no', field: 'survey_no', headerName: 'Survey No', width: 120 },
//     { id: 'property_type', field: 'property_type', headerName: 'Property Type', width: 150 },

//     // From AssetValuation fields
//     { id: 'valuation_agency', field: 'valuation_agency', headerName: 'Valuation Agency', width: 200 },
//     { id: 'valuation_work_ord_date', field: 'valuation_work_ord_date', headerName: 'Work Order Date', width: 140 },
//     { id: 'valuation_report_date', field: 'valuation_report_date', headerName: 'Report Date', width: 140 },
//     { id: 'valuation_status', field: 'valuation_status', headerName: 'Status', width: 120 },
//     { id: 'area', field: 'area', headerName: 'Area', width: 120 },
//     { id: 'guideline_value', field: 'guideline_value', headerName: 'Guideline Value', width: 150 },
//     { id: 'building_value', field: 'building_value', headerName: 'Building Value', width: 150 },
//     { id: 'total_value', field: 'total_value', headerName: 'Total Value', width: 150 },
//     { id: 'valuation_report', field: 'valuation_report', headerName: 'Valuation Report', width: 250 },
//   ];

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/asset-mgmt/asset-valuation/`) 
//       .then((response) => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           name_of_fe: item.asset_property_base?.asset3_2_base?.fe?.name_of_fe || '-',
//           name_of_ca: item.asset_property_base?.asset3_2_base?.fe?.name_of_ca || '-',
//           notification: item.asset_property_base?.asset3_2_base?.notification || '-',
//           date: item.asset_property_base?.asset3_2_base?.date
//             ? new Date(item.asset_property_base.asset3_2_base.date).toLocaleDateString('en-GB').replace(/\//g, '-')
//             : '-',
//           notification_no: item.asset_property_base?.asset3_2_base?.notification_no || '-',

//           property_detals: item.asset_property_base?.property_detals || '-',
//           survey_no: item.asset_property_base?.survey_no || '-',
//           property_type: item.asset_property_base?.property_type || '-',

//           valuation_agency: item.valuation_agency || '-',
//           valuation_work_ord_date: item.valuation_work_ord_date
//             ? new Date(item.valuation_work_ord_date).toLocaleDateString('en-GB').replace(/\//g, '-')
//             : '-',
//           valuation_report_date: item.valuation_report_date
//             ? new Date(item.valuation_report_date).toLocaleDateString('en-GB').replace(/\//g, '-')
//             : '-',
//           valuation_status: item.valuation_status || '-',
//           area: item.area || '-',
//           guideline_value: item.guideline_value || '-',
//           building_value: item.building_value || '-',
//           total_value: item.total_value || '-',
//           valuation_report: item.valuation_report || '-',
//         }));

//         setRows(apiData);
//         setSnackbarMessage('Asset Valuation data loaded successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Failed to fetch Asset Valuation data:', error);
//         setSnackbarMessage('Failed to load Asset Valuation data.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   }, []);

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   if (loading) {
//     return <LoadingSpinner size={30} />;
//   }

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//         backgroundColor: '#fff',
//       }}
//     >
//       <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
//         <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
//           Asset Valuation
//         </Typography>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus
//         enableSort
//         sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };


import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography } from '@mui/material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { API_BASE_URL } from '../../config';
import { LoadingSpinner } from '../../Components/spinner/spinner';

export const StaffAssetValuationComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl. No', width: 70 },
    { id: 'name_of_fe', field: 'name_of_fe', headerName: 'Financial Establishment', width: 250 },
    { id: 'name_of_ca', field: 'name_of_ca', headerName: 'Competent Authority', width: 200 },

    {
      id: 'notification',
      field: 'notification',
      headerName: 'Notification',
      width: 150,
      renderCell: (params) =>
        params.value && params.value !== '-' ? (
          <a
            href={params.value}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1976d2', textDecoration: 'none', fontWeight: 500 }}
          >
            View
          </a>
        ) : (
          <span>-</span>
        ),
    },
    { id: 'date', field: 'date', headerName: 'Date', width: 120 },
    { id: 'notification_no', field: 'notification_no', headerName: 'Notification No', width: 150 },

    { id: 'property_detals', field: 'property_detals', headerName: 'Property Details', width: 200 },
    { id: 'survey_no', field: 'survey_no', headerName: 'Survey No', width: 120 },
    { id: 'property_type', field: 'property_type', headerName: 'Property Type', width: 150 },

    { id: 'valuation_agency', field: 'valuation_agency', headerName: 'Valuation Agency', width: 200 },
    {
      id: 'valuation_work_ord_date',
      field: 'valuation_work_ord_date',
      headerName: 'Work Order Date',
      width: 140,
    },
    {
      id: 'valuation_report_date',
      field: 'valuation_report_date',
      headerName: 'Report Date',
      width: 140,
    },
    { id: 'valuation_status', field: 'valuation_status', headerName: 'Status', width: 120 },
    { id: 'area', field: 'area', headerName: 'Area', width: 120 },
    { id: 'guideline_value', field: 'guideline_value', headerName: 'Guideline Value', width: 150 },
    { id: 'building_value', field: 'building_value', headerName: 'Building Value', width: 150 },
    { id: 'total_value', field: 'total_value', headerName: 'Total Value', width: 150 },

    {
      id: 'valuation_report',
      field: 'valuation_report',
      headerName: 'Valuation Report',
      width: 250,
      renderCell: (params) =>
        params.value && params.value !== '-' ? (
          <a
            href={params.value}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1976d2', textDecoration: 'none', fontWeight: 500 }}
          >
            View
          </a>
        ) : (
          <span>-</span>
        ),
    },
  ];

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/asset-mgmt/asset-valuation/`)
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          name_of_fe: item.asset_property_base?.asset3_2_base?.fe?.name_of_fe || '-',
          name_of_ca: item.asset_property_base?.asset3_2_base?.fe?.name_of_ca || '-',
          notification: item.asset_property_base?.asset3_2_base?.notification || '-',
          date: item.asset_property_base?.asset3_2_base?.date
            ? new Date(item.asset_property_base.asset3_2_base.date).toLocaleDateString('en-GB').replace(/\//g, '-')
            : '-',
          notification_no: item.asset_property_base?.asset3_2_base?.notification_no || '-',

          property_detals: item.asset_property_base?.property_detals || '-',
          survey_no: item.asset_property_base?.survey_no || '-',
          property_type: item.asset_property_base?.property_type || '-',

          valuation_agency: item.valuation_agency || '-',
          valuation_work_ord_date: item.valuation_work_ord_date
            ? new Date(item.valuation_work_ord_date).toLocaleDateString('en-GB').replace(/\//g, '-')
            : '-',
          valuation_report_date: item.valuation_report_date
            ? new Date(item.valuation_report_date).toLocaleDateString('en-GB').replace(/\//g, '-')
            : '-',
          valuation_status: item.valuation_status || '-',
          area: item.area || '-',
          guideline_value: item.guideline_value || '-',
          building_value: item.building_value || '-',
          total_value: item.total_value || '-',
          valuation_report: item.valuation_report_link || item.valuation_report || '-',
        }));

        setRows(apiData);
        setSnackbarMessage('Asset Valuation data loaded successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to fetch Asset Valuation data:', error);
        setSnackbarMessage('Failed to load Asset Valuation data.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  }, []);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
        <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
          Asset Valuation
        </Typography>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
